<!-- eslint-disable -->
<template>
    <div>
        <div class="columns is-mobile confirmation is-multiline">
            <span class="column confirmation-desc">
                Учитель
                <router-link :to="{
                                 name: 'user:profile',
                                 params: {
                                     type: confirmation.teacher.type,
                                     id: confirmation.teacher.id
                                 }
                             }"
                >
                    {{ confirmation.teacher.fullName }}
                </router-link>
                {{ phrase }}
                <router-link :to="{
                                 name: 'user:profile',
                                 params: {
                                     type: confirmation.student.type,
                                     id: confirmation.student.id
                                 }
                             }"
                >
                    {{ confirmation.student.fullName }}
                </router-link>
            </span>
            <button class="button is-info is-outlined column is-narrow confirmation-button"
                    title="Подтвердить"
                    @click="updateConfirmation(confirmation.id, true)"
            >
                <i class="fa" :class="isGreenButtonLoading ? 'fa-spinner' : 'fa-check'"></i>
            </button>
            <button class="button is-danger is-outlined column is-narrow confirmation-button"
                    title="Отклонить"
                    @click="updateConfirmation(confirmation.id, false)"
            >
                <i class="fa" :class="isRedButtonLoading ? 'fa-spinner' : 'fa-times'"></i>
            </button>
        </div>
        <hr>
    </div>
</template>

<script>
    /*eslint-disable*/
    import ConfirmationApi from "../../../api/confirmation"

    export default {
        props: {
            index: Number,
            confirmation: Object
        },
        data () {
            return {
                isGreenButtonLoading: false,
                isRedButtonLoading: false
            }
        },
        methods: {
            updateConfirmation (id, status) {
                status ? this.isGreenButtonLoading = true : this.isRedButtonLoading = true;
                ConfirmationApi.update(id, { status })
                    .then(data => {
                        this.$emit('remove');
                        status ? this.isGreenButtonLoading = false : this.isRedButtonLoading = false;
                        return data;
                    })
                    .catch(err => {
                        status ? this.isGreenButtonLoading = false : this.isRedButtonLoading = false;
                        if (err && err.response && err.response.status === 404) {
                            this.$toasted.error('На это подтвержение уже ответили.');
                            this.$emit('remove');
                        } else {
                            this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                        }
                    });
            }
        },
        computed: {
            phrase () {
                if (this.confirmation.points >= 0) {
                    return `хочет добавить ${this.points} ученику`;
                } else {
                    return `хочет убрать ${this.points} у ученика`;
                }
            },
            points () {
                let points = this.confirmation.points >= 0 ? this.confirmation.points : -this.confirmation.points;
                if (points%10 === 1 && points !== 11) {
                    return `${points} балл`;
                } else if (points%10 <= 4 && points%10 >= 2 && ![12, 13, 14].includes(points)) {
                    return `${points} балла`;
                }
                return `${points} баллов`;
            }
        }
    }
</script>
